<template>
  <div v-if="siteSearch">

    <el-row v-if="this.isTowerCo() && !actionData.organisation_id">
      <el-col :span="4">
        <h3>Select Sharer</h3>
      </el-col>

      <el-col :span="20">
        <select-sharer v-model="actionData.organisation_id" no-form @change="selectSharer" />
      </el-col>

    </el-row>

    <el-row v-else>
      <div v-if="this.isTowerCo()">
        <el-col :span="4">
          <h3>Selected Sharer</h3>
        </el-col>
        <el-col :span="20" >
          <strong v-if="actionData.organisation && actionData.organisation.name">{{actionData.organisation.name}}</strong>
        </el-col>
      </div>
    </el-row>


    <el-row align="middle">

      <el-col align="center" :span="4">
        <h3 style="color: ivorywhite;">Select Site</h3>
      </el-col>

        <el-col :span="20">
          <select-site ref="siteSelector" v-model="actionData.site_id" label="" @change="selectSite" />
      </el-col>

    </el-row>
  </div>

</template>


<script>

import SiteMixins from '@/mixins/SiteMixins'

import SelectSharer from '@/components/atoms/selects/SelectSharer'
import SelectSite from '@/components/atoms/selects/SelectSite'

export default {
  mixins: [SiteMixins],

  components: {
    SelectSharer,
    SelectSite
  },

  props: {
    search: {
      type: Boolean,
      default: true
    },
    rowData: {
      type: Object,
      default: null
    }
  },

  methods: {
    findSiteCallback: function (response) {

      if (!response) {
        return
      }

      if (response && response.data || this.isArray(response) && response.length > 1) {

        this.sites = response.data ? response.data : response

      } else {

        this.localSite = this.isArray(response) ? response[0] : response
        this.actionData.site_id = this.localSite.id

        this.$set(this.actionData, 'site', this.clone(response))

        this.siteSearch = !this.actionData.organisation_id ? true : false

        if (this.actionData.site_id) {
          if (this.isNew) {
            this.actionData.id = null
          }
        } else {
          this.actionData.site_id = this.actionData.site.id
        }

        this.$emit('changed', this.localSite, this.actionData)
      }
    },

    findSiteError: function (err) {
      self.$message({
        title: 'Site Info',
        message: 'Unable to fetch site info for id: [' + this.siteId + '] ' + err,
        type: 'warning'
      })
    },

    selectSite () {
      this.siteSearch = (this.actionData.site_id && this.actionData.organisation_id ? false : true)

      if (this.isTelco()) {
        this.actionData.organisation_id = this.org().id
        this.actionData.organisation = this.org()
      }

      this.findSite(this.actionData.site_id, this.findSiteCallback, this.findSiteError)
    },

    selectSharer: function (value) {

      if (!this.actionData.organisation) {
        this.actionData.organisation = {}
      }

      this.actionData.organisation.name = this.$refs.selector.selected.currentLabel
    },

    findSiteTelco: function (response) {
      if (response && response.id) {
        this.actionData.organisation_id = response.id
        this.actionData.organisation = response
        this.$emit('changed-telco', this.localSite, this.actionData)
      }
    }

  },   // methods

  data () {
    return {
      siteSearch: this.search,
      actionData: this.rowData,
      siteId: this.rowData ? this.rowData.site_id : null,
      loading: false,
      localSite: null,
      sites: []
    }
  },

  beforeMount () {

    if (this.siteId) {
      this.findSite(this.siteId, this.findSite, this.findSiteError)
    }
  }

}

</script>

<style scoped>
.el-select {display: inline-block; width: 100%;}
</style>



// WEBPACK FOOTER //
// RequestSearch.vue?62bf571a